import {handleError, useToggle} from 'helpers';

export function useAsyncAction(callback: () => Promise<any>) {
  const [isBusy, toggleBusy] = useToggle(false);
  const start = async () => {
    try {
      toggleBusy();
      await callback();
    } catch (error) {
      handleError(error);
    }
    toggleBusy();
  };
  return {
    'aria-busy': String(isBusy),
    'onClick': isBusy ? undefined : start
  };
}
